import { createElementBlock as t, openBlock as o, normalizeClass as a, renderSlot as s } from "vue";
const l = ["aria-rowindex"], c = /* @__PURE__ */ Object.assign({
  name: "DsTableRow"
}, {
  __name: "table-row",
  props: {
    rowIndex: { type: Number, required: !0 },
    stretch: { type: Boolean, default: !1 }
  },
  setup(e) {
    return (r, n) => (o(), t("div", {
      class: a(["ds-table__row", { "ds-table__row--stretched": e.stretch }]),
      role: "row",
      "aria-rowindex": e.rowIndex
    }, [
      s(r.$slots, "default")
    ], 10, l));
  }
});
export {
  c as default
};
